import { useEffect } from 'react';

/** Signals that the current lazy route has mounted (splash may fade). Works with BrowserRouter. */
export default function RoutePaintNotifier() {
  useEffect(() => {
    window.dispatchEvent(new CustomEvent('daiv-route-painted'));
  }, []);
  return null;
}
